import React from 'react';
import { useModal } from '../../Context/ModalContext';
import { modal } from './Modal.css';

const ModalComponent = () => {
    const { isModalOpen, modalContent, closeModal } = useModal();

    if (!isModalOpen) return null;

    setTimeout(() => {
        closeModal();
    }, modalContent.time ? modalContent.time : 3000);


    return (
        <div css={modal}>
            <div className="ModalContent">
                            <div className="ContainerClose">
                                <i className="pi pi-times" onClick={closeModal}></i>
                            </div>
                {
                    modalContent?.children ? (
                        modalContent.children
                    ) : (
                        <>
                            <h2 className='Title'>{modalContent.title}</h2>
                            <div className='Content'>
                                <p>{modalContent.message}</p>
                            </div>
                        </>
                    )
                }
            </div>
        </div>

    );
};

export default ModalComponent;